import React, { useState } from "react";
import Header from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import Select from "react-select";
import CountUp from "react-countup";
import { Helmet } from "react-helmet-async";

import {
  blogimg12,
  blogimg4,
  blogimg6,
  doctor_dashboard_01,
  doctor_dashboard_02,
  doctor_dashboard_03,
  doctor_dashboard_04,
  imgicon,
  adminUse,
  profileicon,
  sorticon,
  sorticon02,
  timericon,
  trashicon,
  chaticon1,
} from "../../components/imagepath";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import RadialPatientsChart from "./DonutChart";
import { Link } from "react-router-dom";
import ActivityChart from "./ActivityChart";
import MarketAreaChart from "./IncomeChart";
import RadialBarChart from "./FullChart";
import { use } from "react";

const Home = () => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [options, setOptions] = useState([
    { value: 1, label: "This Week" },
    { value: 2, label: "Last Week" },
    { value: 3, label: "This Month" },
    { value: 4, label: "Last Month" },
  ]);

  const [year, setyear] = useState([
    { value: 1, label: "2025" },
    { value: 2, label: "2024" }
  ]);

  // Mock data for CMS dashboard
  const [dashboardData] = useState({
    totalVisitors: 800,
    totalUsers: 10,
    totalPosts: 15,
    totalComments: 163,
    bounceRate: 42.3,
    avgSession: "4m 12s",
    topPages: [
      { name: "Homepage", visits: 8450 },
      { name: "Blog Post - React Guide", visits: 3240 },
      { name: "About Us", visits: 2870 },
      { name: "Contact Page", visits: 1860 }
    ],
    recentPosts: [
      { title: "Getting Started Data Science", author: "S. Kankal", date: "2 hours ago", status: "Published" },
      { title: "New Technology in Block Chain", author: "Dr. Shilpa Joshi", date: "5 hours ago", status: "Published" },
      { title: "CMS Best Practices", author: "Anuja R. Tungar", date: "1 day ago", status: "Draft" }
    ],
    userActivity: [
      { time: "08:00", activity: "User registrations peak" },
      { time: "10:00", activity: "Content publishing high" },
      { time: "14:00", activity: "Comment activity peak" },
      { time: "18:00", activity: "Traffic surge" }
    ]
  });

  return (
    <>
      <Helmet>
        <title>Dashboard | CMS</title>
      </Helmet>
      <Header />
      <Sidebar
        id="menu-item"
        id1="menu-items"
        activeClassName="cms-dashboard"
      />
      <>
        <div className="page-wrapper">
          <div className="content">
            {/* Page Header */}
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="#">Dashboard </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <i className="feather-chevron-right">
                        <FeatherIcon icon="chevron-right" />
                      </i>
                    </li>
                    <li className="breadcrumb-item active">CMS Dashboard</li>
                  </ul>
                </div>
              </div>
            </div>
            {/* /Page Header */}

            <div className="good-morning-blk">
              <div className="row">
                <div className="col-md-6">
                  <div className="morning-user">
                    <h2>
                      Welcome Back, <span>Admin</span>
                    </h2>
                    <p>Here's what's happening with your website today</p>
                  </div>
                </div>
                <div className="col-md-6 position-blk">
                  <div className="morning-img">
                    <img src={adminUse} alt="Dashboard" />
                  </div>
                </div>
              </div>
            </div>

            {/* Stats Cards */}
            <div className="doctor-list-blk">
              <div className="row">
                <div className="col-xl-3 col-md-6">
                  <div className="doctor-widget border-right-bg">
                    <div className="doctor-box-icon flex-shrink-0">
                      <i className="fa-solid fa-users text-white"></i>
                    </div>

                    <div className="doctor-content dash-count flex-grow-1">
                      <h4>
                        <CountUp delay={0.4} end={dashboardData.totalVisitors} duration={0.6} separator="," />
                        <span className="status-green">+12%</span>
                      </h4>
                      <h5>Total Visitors</h5>
                      <p>This month</p>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-md-6">
                  <div className="doctor-widget border-right-bg">
                    <div className="doctor-box-icon flex-shrink-0">
                      <i className="fa-solid fa-user text-white text-2xl"></i>
                    </div>


                    <div className="doctor-content dash-count flex-grow-1">
                      <h4>
                        <CountUp delay={0.4} end={dashboardData.totalUsers} duration={0.6} separator="," />
                        <span className="status-green">+8%</span>
                      </h4>
                      <h5>Registered Users</h5>
                      <p>Active accounts</p>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-md-6">
                  <div className="doctor-widget border-right-bg">
                    <div className="doctor-box-icon flex-shrink-0">
                      <i className="fa-solid fa-pen-to-square text-white text-2xl"></i>
                    </div>





                    <div className="doctor-content dash-count flex-grow-1">
                      <h4>
                        <CountUp delay={0.4} end={dashboardData.totalPosts} duration={0.6} />
                        <span className="status-green">+15%</span>
                      </h4>
                      <h5>Total Blogs</h5>
                      <p>Published content</p>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-md-6">
                  <div className="doctor-widget">
                    <div className="doctor-box-icon flex-shrink-0">
                      <i className="fa-solid fa-robot text-white text-2xl"></i>
                    </div>

                    <div className="doctor-content dash-count flex-grow-1">
                      <h4>
                        <CountUp delay={0.4} end={dashboardData.totalComments} duration={0.6} />
                        <span className="status-green">+25%</span>
                      </h4>
                      <h5>Bot</h5>
                      <p>Sessions</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              {/* Traffic Analytics */}
              <div className="col-12 col-md-12 col-lg-12 col-xl-7">
                <div className="card">
                  <div className="card-body">
                    <div className="chart-title patient-visit mb-0">
                      <h4>Website Traffic Analytics</h4>
                      <div className="income-value">
                        <h3>
                          <span>{dashboardData.totalVisitors.toLocaleString()}</span>
                        </h3>
                        <p>
                          <span className="passive-view">
                            <i className="feather-arrow-up-right me-1">
                              <FeatherIcon icon="arrow-up-right me-1" />
                            </i>
                            12%
                          </span>{" "}
                          vs last month
                        </p>
                      </div>
                      <div className="form-group mb-0">
                        <Select
                          defaultValue={selectedOption}
                          onChange={setSelectedOption}
                          options={year}
                          id="search-commodity"
                          components={{
                            IndicatorSeparator: () => null
                          }}
                          styles1={{
                            control: (baseStyles, state) => ({
                              ...baseStyles,
                              borderColor: state.isFocused ? 'none' : '2px solid rgba(46, 55, 164, 0.1);',
                              boxShadow: state.isFocused ? '0 0 0 1px #2e37a4' : 'none',
                              '&:hover': {
                                borderColor: state.isFocused ? 'none' : '2px solid rgba(46, 55, 164, 0.1)',
                              },
                              borderRadius: '10px',
                              fontSize: "14px",
                              minHeight: "45px",
                            }),
                            dropdownIndicator: (base, state) => ({
                              ...base,
                              transform: state.selectProps.menuIsOpen ? 'rotate(-180deg)' : 'rotate(0)',
                              transition: '250ms',
                              width: '35px',
                              height: '35px',
                            }),
                          }}
                        />
                      </div>
                    </div>
                    <div id="apexcharts-area" />
                    <MarketAreaChart />
                  </div>
                </div>
              </div>

              {/* User Engagement */}
              <div className="col-12 col-md-12 col-lg-6 col-xl-3 d-flex">
                <div className="card">
                  <div className="card-body">
                    <div id="radial-patients" />
                    <RadialPatientsChart />
                  </div>
                </div>
              </div>

              {/* Performance Metrics */}
              <div className="col-12 col-md-12 col-lg-6 col-xl-2 d-flex">
                <div className="struct-point">
                  <div className="card patient-structure">
                    <div className="card-body">
                      <h5>Bounce Rate</h5>
                      <h3>
                        {dashboardData.bounceRate}%
                        <span className="status-pink">
                          <img src={sorticon02} alt="" className="me-1" />
                          -5%
                        </span>
                      </h3>
                    </div>
                  </div>
                  <div className="card patient-structure">
                    <div className="card-body">
                      <h5>Avg. Session</h5>
                      <h3>
                        {dashboardData.avgSession}
                        <span className="status-green">
                          <img src={sorticon} alt="" className="me-1" />
                          +12%
                        </span>
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-12 col-md-12 col-xl-7">
                {/* User Activity Chart */}
                <div className="card">
                  <div className="card-body">
                    <div className="chart-title patient-visit">
                      <h4>User Activity</h4>
                      <div>
                        <ul className="nav chat-user-total">
                          <li>
                            <i className="fa fa-circle low-users" aria-hidden="true" />
                            Low Activity
                          </li>
                          <li>
                            <i className="fa fa-circle current-users" aria-hidden="true" />
                            High Activity
                          </li>
                        </ul>
                      </div>
                      <div className="form-group mb-0">
                        <Select
                          defaultValue={selectedOption}
                          onChange={setSelectedOption}
                          options={options}
                          id="search-commodity"
                          components={{
                            IndicatorSeparator: () => null
                          }}
                          styles1={{
                            control: (baseStyles, state) => ({
                              ...baseStyles,
                              borderColor: state.isFocused ? 'none' : '2px solid rgba(46, 55, 164, 0.1);',
                              boxShadow: state.isFocused ? '0 0 0 1px #2e37a4' : 'none',
                              '&:hover': {
                                borderColor: state.isFocused ? 'none' : '2px solid rgba(46, 55, 164, 0.1)',
                              },
                              borderRadius: '10px',
                              fontSize: "14px",
                              minHeight: "45px",
                            }),
                            dropdownIndicator: (base, state) => ({
                              ...base,
                              transform: state.selectProps.menuIsOpen ? 'rotate(-180deg)' : 'rotate(0)',
                              transition: '250ms',
                              width: '35px',
                              height: '35px',
                            }),
                          }}
                        />
                      </div>
                    </div>
                    <ActivityChart />
                    <div id="activity-chart" />
                  </div>
                </div>

                <div className="row">
                  {/* Recent Posts */}
                  <div className="col-12 col-md-12 col-xl-8">
                    <div className="card">
                      <div className="card-header">
                        <h4 className="card-title d-inline-block">
                          Recent Posts
                        </h4>{" "}
                        <Link
                          to="/posts"
                          className="patient-views float-end"
                        >
                          Show all
                        </Link>
                      </div>
                      <div className="card-body p-0 table-dash">
                        <div className="table-responsive">
                          <table className="table mb-0 border-0 custom-table">
                            <tbody>
                              {dashboardData.recentPosts.map((post, index) => (
                                <tr key={index}>
                                  <td className="table-image appoint-doctor">
                                    <img
                                      width={28}
                                      height={28}
                                      className="rounded-circle"
                                      src={blogimg4}
                                      alt={post.author}
                                    />
                                    <h2>{post.title}</h2>
                                  </td>
                                  <td className="appoint-time text-center">
                                    <h6>By {post.author}</h6>
                                    <span>{post.date}</span>
                                  </td>
                                  <td>
                                    <span className={`badge ${post.status === 'Published' ? 'bg-success' : 'bg-warning'}`}>
                                      {post.status}
                                    </span>
                                  </td>
                                  <td>
                                    <button className="check-point status-green me-1">
                                      <i className="feather-edit">
                                        <FeatherIcon icon="edit" />
                                      </i>
                                    </button>
                                    <button className="check-point status-pink ">
                                      <i className="feather-trash-2">
                                        <FeatherIcon icon="trash-2" />
                                      </i>
                                    </button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* System Status */}
                  <div className="col-12 col-md-12 col-xl-4 d-flex">
                    <div className="card wallet-widget">
                      <div className="circle-bar circle-bar2">
                        <div className="circle-graph2" data-percent={85}>
                          <RadialBarChart duration={10} />
                          <b>
                            <img src={timericon} alt="System Status" />
                          </b>
                        </div>
                      </div>
                      <div className="main-limit">
                        <p>System Uptime</p>
                        <h4>99.8%</h4>
                        <span className="status-green">All systems operational</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Right Sidebar - Top Pages & Activity */}
              <div className="col-12 col-lg-12 col-xl-5 d-flex">
                <div className="card flex-fill comman-shadow">
                  <div className="card-header">
                    <h4 className="card-title d-inline-block">
                      Top Performing Pages
                    </h4>{" "}
                    <Link
                      to="/analytics"
                      className="patient-views float-end"
                    >
                      View Details
                    </Link>
                  </div>
                  <div className="card-body">
                    <div className="teaching-card">
                      <ul className="steps-history">
                        <li>Page</li>
                        <li>Visits</li>
                      </ul>
                      <ul className="activity-feed">
                        {dashboardData.topPages.map((page, index) => (
                          <li key={index} className="feed-item d-flex align-items-center">
                            <div className="dolor-activity">
                              <ul className="doctor-date-list mb-2">
                                <li>
                                  <i className="fas fa-file me-2" />
                                  {page.name}
                                  <span className="float-end">{page.visits.toLocaleString()}</span>
                                </li>
                              </ul>
                            </div>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>

                  {/* Recent Activity */}
                  <div className="card-header mt-3">
                    <h4 className="card-title d-inline-block">
                      Recent Activity
                    </h4>
                  </div>
                  <div className="card-body">
                    <div className="teaching-card">
                      <ul className="activity-feed">
                        {dashboardData.userActivity.map((activity, index) => (
                          <li key={index} className="feed-item d-flex align-items-center">
                            <div className="dolor-activity">
                              <ul className="doctor-date-list mb-2">
                                <li>
                                  <i className="fas fa-circle me-2" />
                                  {activity.time} <span>{activity.activity}</span>
                                </li>
                              </ul>
                            </div>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default Home;